export default {"src":"/_next/static/image/public/images/menu_rx_green.39fae2992798ffd72aac3ed092669c9b.svg","height":15,"width":13};